import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { lastValueFrom, Observable } from 'rxjs';
import { Category } from '../../../models/category.model';
import { superAdminHttpRoutes, superAdminHttpVersion } from '../../../consts/super_admin_http_routes';
import { ApiService } from '../api.services';
import { portalHttpRoutes, portalHttpVersion } from '../../../consts/portal_http_routes';


@Injectable({
  providedIn: 'root'
})
export class CategoryService {

  private url: string = superAdminHttpVersion.V1;

  private portalUrl: string = portalHttpVersion.V1;


  constructor(private _httpClient: HttpClient, private apiService: ApiService,) {
  }

  filter(q: string, page_number?: number, page_size?: number): Observable<any> {
    let params = new HttpParams();
    params = params.set('q', q);
    if (page_number) {
      params = params.set('page_number', page_number);
    }
    if (page_size) {
      params = params.set('page_size', page_size);
    }
    //return this._httpClient.get<any>(`${this.url}`, { params });
    return this._httpClient.get<any>(`${this.url}${superAdminHttpRoutes.CATEGORIES_GET_TABLE}`, { params });

  }

  getCategoryUser(q: string, page_number?: number, page_size?: number, company_courses?: boolean): Observable<any> {
    let params = new HttpParams();
    params = params.set('q', q);
    if (page_number) {
      params = params.set('page_number', page_number);
    }
    if (company_courses != null) {
      params = params.set('company_courses', company_courses);
    }
    if (page_size) {
      params = params.set('page_size', page_size);
    }
    return this.apiService.httpGetCall(`${this.portalUrl}${portalHttpRoutes.PORTAL_CATEGORY_GET_TABLE}`, params);
  }
  getCategory(id: string): Observable<any> {
    return this._httpClient.get(`${this.url}/${id}`);
  }

  getAllCategory(): Observable<any> {
    return this.apiService.httpGetCallWithoutParameter(`${this.url}product-category`);
  }

  //  async getAllCategory(){
  //     // return await lastValueFrom(this._httpClient.get<any>(`${this.url}/certificates`));

  //     return await lastValueFrom(this._httpClient.get<any>(`${this.url}product-category`));
  //   }


  save(category: Category): Observable<any> {
    return this._httpClient.post(`${this.url}`, category);
  }
  update(id: string, category: Category): Observable<any> {
    return this._httpClient.patch(`${this.url}/${id}`, category);
  }
  updateImage(id: string, form: any): Observable<any> {
    return this.apiService.httpPutCall(`${this.url}product-category/${id}`, form);
  }

  uploadCategoryImage(file: File, category_name: string): Observable<any> {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("bucketName", "sos-superadmin-portal");
    formData.append("dirPath", `categories/${category_name}`);

    return this.apiService.httpPostCall<any>(
      `${this.url}${superAdminHttpRoutes.UPLOAD_PRODUCT_LOGO}`,
      formData
    );
  }

}
